import React, { Component } from 'react';

export default class GDPROptin extends Component {
  constructor(props){
    super(props)
		this.state = {
			checked: false,
			show: false,
		}
  }
  handleCheck(){
    let that = this
		this.setState({checked: !this.state.checked}, function(){
      window.myForm.addHiddenFields({
        GDPR_Email_Opt_In__c: that.state.checked
      })
		});
  }

	render(){
		return (
			<div id="GDPREmailOptIn" className="check-wrapper">
        <input id="chkEmailMe" type="checkbox" onChange={this.handleCheck.bind(this)} defaultChecked={this.state.checked} />
        <label htmlFor="chkEmailMe">Yes, email me</label>
        <p className="description">I wish to receive information, via email, from Planview Inc. (“Planview”) regarding Planview’s
          products, free educational resources, events, surveys, promotional offers, and tips for using
          Planview’s software. I can withdraw my consent to the use of my email address, at any time and
          free of cost, by clicking the unsubscribe link at the bottom of any email.</p>
      </div>
		)
	}
}	
